const SET_PRODUCT_DETAIL = "SET_PRODUCT_DETAIL";
const SET_LOGIN_STATUS = "SET_LOGIN_STATUS";
const ADD_TO_CART = "ADD_TO_CART";
 const ADD_TEMPORARY_CART_ITEM="ADD_TEMPORARY_CART_ITEM"
const INCREMENT_CART_ITEM = "INCREMENT_CART_ITEM";
const DECREMENT_CART_ITEM = "DECREMENT_CART_ITEM";
const CLEAR_CART = "CLEAR_CART";
export {
  SET_PRODUCT_DETAIL,
  SET_LOGIN_STATUS,
  ADD_TO_CART,
  ADD_TEMPORARY_CART_ITEM,
  INCREMENT_CART_ITEM,
  DECREMENT_CART_ITEM,
  CLEAR_CART,
};
